// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6e43554649354bfb0ad945636dacd7c497307c68.chunk.js";
};